import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5","key":"svg-1"}]]

const IconWashDryP = createReactComponent('outline', 'wash-dry-p', 'WashDryP', __iconNode);

export default IconWashDryP;